export const popularCountries = [
  { name: 'Algeria', img: 'algeria.svg' },
  { name: 'Angola', img: 'angola.svg' },
  { name: 'Benin', img: 'benin.svg' },
  { name: 'Chad', img: 'chad.svg' },
  { name: 'Cote d’Ivoire', img: 'cotedIvoire.svg' },
];
